module.exports = __webpack_public_path__ + "img/d.3e5399c0.png";